import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import ListItem from "./components/ListItem";
import { orderedStyles, unorderedStyles } from "./ListTypes";

var getKey = function getKey(obj, val) {
  return Object.keys(obj).find(function (key) {
    return obj[key] === val;
  });
};

var ORDERED_STYLE = "ORDERED_STYLE";
var UNORDERED_STYLE = "UNORDERED_STYLE";

var getListTypeFromValue = function getListTypeFromValue(val) {
  if (getKey(orderedStyles, val)) {
    return ORDERED_STYLE;
  } else if (getKey(unorderedStyles, val)) {
    return UNORDERED_STYLE;
  }

  return null;
};

var List = function List(_ref) {
  var children = _ref.children,
      listStyle = _ref.listStyle;
  var getClassName = getClassNameFactory(List.displayName);
  var listAttrs = {
    style: {
      listStyleType: listStyle
    },
    className: getClassName({
      descendantName: "items"
    })
  };
  var listType = getListTypeFromValue(listStyle);

  if (listType === null) {
    throw new Error("listStyle is not valid, see ListTypes.ts for options");
  }

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, listType === ORDERED_STYLE && /*#__PURE__*/React.createElement("ol", listAttrs, children), listType === UNORDERED_STYLE && /*#__PURE__*/React.createElement("ul", listAttrs, children));
};

List.defaultProps = {
  listStyle: "disc"
};
List.displayName = "List";
List.Item = ListItem;
export default List;